import { mapActions, mapGetters } from "vuex";

import mainSelect from "@/components/atoms/main-select/index.vue";
import mainInput from "@/components/atoms/main-input/index.vue";
import mainCheckbox from "@/components/atoms/main-checkbox/index.vue";

import VisaIcon from "@/assets/img/visa-card.png";
import MastercardIcon from "@/assets/img/mastercard-card.png";
import VisaSmallIcon from "@/assets/img/visa-small-icon.svg";
import MastercardSmallIcon from "@/assets/img/mastercard-small-icon.svg";

import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "payments-payments-add",
    mixins: [validationMixin],
    data() {
        return {
            country_id: "",
            countryInfo: {},
            payload: {
                country: "",
                number: "",
                expireDate: "",
                month: "",
                year: "",
                cvv: "",
                is_default: false,
            },
            step: 0,
            selectedCountry: {},
            openSelectCountries: false,
            isCardFlipped: false,
            disabledButton: true,
            disabledMobileCardButton: true,
            disabledMobileExpireButton: true,
            disabledMobileSecretButton: true,
            otherCardMask: "XXXX-XXXX-XXXX-XXXX",
            dateCardMask: "MM/YY",
            otherSecretMask: "___ ",
            cardIcon: "",
            cardBoxIcon: "",
        };
    },
    validations() {
        return {
            country: {
                required,
            },
            country_id: {
                required,
            },
        };
    },
    components: {
        mainInput,
        mainSelect,
        mainCheckbox,
    },
    watch: {
        payload: {
            handler() {
                if (
                    this.payload.number.length === 19 &&
                    this.payload.expireDate.length === 5 &&
                    this.payload.cvv.length >= 3
                ) {
                    this.disabledButton = false;
                } else {
                    this.disabledButton = true;
                }

                if (this.payload.number.length === 19) {
                    this.disabledMobileCardButton = false;
                } else {
                    this.disabledMobileCardButton = true;
                }

                if (this.payload.expireDate.length === 5) {
                    this.disabledMobileExpireButton = false;
                } else {
                    this.disabledMobileExpireButton = true;
                }

                if (this.payload.cvv.length >= 3) {
                    this.disabledMobileSecretButton = false;
                } else {
                    this.disabledMobileSecretButton = true;
                }
            },
            deep: true,
        },
    },
    created() {
        if (this.countries.length <= 0) {
            this.fetchCountries().then(() => {
                this.setDefaultCountry();
            });
        } else {
            this.setDefaultCountry();
        }
    },
    computed: {
        ...mapGetters({
            countries: "setting/countries",
            countriesLoading: "setting/countriesLoading",
        }),
    },
    methods: {
        ...mapActions({
            fetchCountries: "setting/GET_COUNTRIES",
            setNewPaymentsMethod: "userPayments/SET_NEW_PAYMENTS_METHOD",
        }),

        setDefaultCountry() {
            const item = this.countries.find((e) => {
                if (e.id === 242) {
                    return e;
                }
            });
            this.countryInfo = item;
            this.country_id = item.id;
            this.countryKey = item.slug;
            this.payload.country = item.slug;
        },

        flipCard(status) {
            this.isCardFlipped = status;
        },

        onChangeNumber(value) {
            this.payload.number = value;
            let visaRegex = /^4[0-9]{0,}$/g;
            let mastercardRegex = /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$/g;

            const number = value.replaceAll("-", "");

            if (number.match(visaRegex)) {
                this.cardIcon = VisaIcon;
                this.cardBoxIcon = VisaSmallIcon;
            } else if (number.match(mastercardRegex)) {
                this.cardIcon = MastercardIcon;
                this.cardBoxIcon = MastercardSmallIcon;
            } else {
                this.cardIcon = "";
                this.cardBoxIcon = "";
            }
        },

        onChangeExpireDate(value) {
            const cardExpires = value

                .replace(
                    /^([1-9]\/|[2-9])$/g,
                    "0$1/" // 3 > 03/
                )
                .replace(
                    /^(0[1-9]|1[0-2])$/g,
                    "$1/" // 11 > 11/
                )
                .replace(
                    /^([0-1])([3-9])$/g,
                    "0$1/$2" // 13 > 01/3
                )
                .replace(
                    /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
                    "$1/$2" // 141 > 01/41
                )
                .replace(
                    /[^\d/]|^[/]*$/g,
                    "" // To allow only digits and `/`
                )
                .replace(
                    /\/\//g,
                    "/" // Prevent entering more than 1 `/`
                );

            this.payload.expireDate = cardExpires;
        },

        onClickIsDefault() {
            this.payload.is_default = !this.payload.is_default;
        },

        onChangeCvv(value) {
            this.payload.cvv = value;
        },

        async onClickButton() {
            const payload = { ...this.payload };

            payload.country = this.countryInfo.slug;
            payload.month = this.payload.expireDate.split("/")[0];
            payload.year = this.payload.expireDate.split("/")[1];

            delete payload.expireDate;

            try {
                const response = await this.setNewPaymentsMethod(payload);

                this.$toasted.success(this.$t("successAddedCard"));

                if (!response.data.url) {
                    this.$router.push({
                        name: "profile-payment-methods",
                    });
                } else {
                    setTimeout(() => {
                        window.location = response.data.url;
                    }, 1000);
                }
            } catch (error) {
                console.error("error", error);

                if (error.response.status === 422) {
                    this.$toasted.error(error.response.data.validation.number);
                }

                if (error.response.status === 400) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        clickNextStep() {
            this.step = this.step + 1;
        },

        clickPrevStep() {
            if (this.step !== 0) {
                this.step = this.step - 1;
            }
        },
    },
};
